
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DependentQuestion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DependentQuestion"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dependentSectionQuestionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiredAnswerOptionIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiredAnswerValues"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":135}};
    doc.loc.source = {"body":"fragment DependentQuestion on DependentQuestion {\n    dependentSectionQuestionId\n    requiredAnswerOptionIds\n    requiredAnswerValues\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
